import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { SlaFieldsResponse, Fields } from './types';

export const getUrl = (baseUrl: BaseUrl, searchQuery: string) =>
	`${baseUrl}/rest/servicedesk/1/sla/field/all?query=${searchQuery || ''}`;

export const transformRestResponse = (response: SlaFieldsResponse): Fields =>
	response.fields.map(({ name, id }) => ({
		label: name,
		value: id,
	}));
